export const PlacementQualities = {
  PERFECT: 7,
  EXCELLENT_AND_PERFECT: 6,
  PERFECT_AND_GOOD: 5,
  ONLY_PERFECT: 4,
  EXCELLENT: 3,
  ONLY_EXCELLENT: 2,
  GOOD: 1,
  NONE: 0,
};

// recently changed wording for each quality label
// perfect -> excellent
// excellent -> good
// good -> fair
export const PlacementQualityToText = {
  [PlacementQualities.PERFECT]: _TL_('Excellent'),
  [PlacementQualities.EXCELLENT]: _TL_('Good'),
  [PlacementQualities.GOOD]: _TL_('Fair'),
  [PlacementQualities.NONE]: _TL_('Poor'),
  [PlacementQualities.PERFECT_AND_GOOD]: _TL_('Excellent'),
  [PlacementQualities.EXCELLENT_AND_PERFECT]: _TL_('Excellent'),
  [PlacementQualities.ONLY_PERFECT]: _TL_('Excellent'),
  [PlacementQualities.ONLY_EXCELLENT]: _TL_('Good'),
};

export const formatFileSize = fileSize => Math.round(fileSize / 1000000);

export const getClosestAspectRatio = (width, height) => {
  const inputRatio = width / height;
  const ratios = {
    '16:9': (16 / 9),
    '9:16': (9 / 16),
    '4:3': (4 / 3),
    '1:1': (1 / 1),
    '9:21': (9 / 21),
    '21:9': (21 / 9),
    '3:4': (3 / 4),
  };
  let closestRatio = null;
  let closestDiff = Math.abs(inputRatio - closestRatio);

  /* eslint-disable no-restricted-syntax */
  for (const [label, ratio] of Object.entries(ratios)) {
    const diff = Math.abs(inputRatio - ratio);
    if (diff < closestDiff) {
      closestDiff = diff;
      closestRatio = label;
    }
  }
  /* eslint-enable no-restricted-syntax */

  return closestRatio;
};

export const formatBrandkitForAPI = (obj) => {
  if (Array.isArray(obj)) {
    return obj.map(formatBrandkitForAPI);
  } else if (obj !== null && typeof obj === 'object') {
    const formattedObj = {};
    Object.keys(obj).forEach((key) => {
      if (key === 'Id') {
        formattedObj.Id = parseInt(obj[key], 10);
      } else if (key === 'SubType') {
        formattedObj.SubType = 'None';
      } else if (obj[key] === null) {
        formattedObj[key] = [];
      } else if (key !== 'Type') {
        formattedObj[key] = formatBrandkitForAPI(obj[key]);
      }
    });
    return formattedObj;
  }
  return obj;
};

export const VideoSourceType = {
  AIGenerated: 'AIGenerated',
};

